import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Textarea } from "@/components/ui/textarea";
import { useT } from "@/lib/i18n/use-t";
import { T } from "./goal-list-form.i18n";
import type { ComponentFormProps } from "./types";

/** QL-281 — config of the PDF goal_list block. */
export type GoalListConfig = {
  title?: string;
  description?: string;
  /** Print a Description column (only when at least one goal has one). Default false. */
  showDescription?: boolean;
};

type GoalListFormProps = ComponentFormProps<GoalListConfig> & {
  componentDescription?: string;
};

export function GoalListForm({ config, onChange, componentDescription }: GoalListFormProps) {
  const t = useT(T);

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="goal-list-title">{t.title}</Label>
        <Input
          id="goal-list-title"
          value={config.title || ""}
          onChange={(e) => onChange({ ...config, title: e.target.value })}
          placeholder={t.titlePlaceholder}
        />
        <p className="text-xs text-muted-foreground">{t.titleHelp}</p>
      </div>

      <div className="space-y-2">
        <Label htmlFor="goal-list-description">{t.description}</Label>
        <Textarea
          id="goal-list-description"
          value={config.description || ""}
          onChange={(e) => onChange({ ...config, description: e.target.value })}
          placeholder={t.descriptionPlaceholder}
          rows={2}
        />
        <p className="text-xs text-muted-foreground">{t.descriptionHelp}</p>
      </div>

      <div className="flex items-center justify-between gap-4">
        <div className="space-y-0.5">
          <Label htmlFor="goal-list-show-description">{t.showDescription}</Label>
          <p className="text-xs text-muted-foreground">{t.showDescriptionHelp}</p>
        </div>
        <Switch
          id="goal-list-show-description"
          checked={config.showDescription === true}
          onCheckedChange={(checked) => onChange({ ...config, showDescription: checked })}
        />
      </div>

      {componentDescription && (
        <p className="text-sm text-muted-foreground border-t pt-4">{componentDescription}</p>
      )}
    </div>
  );
}
